"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOverlayInnerStyles = exports.getAvatarAddBtnStyles = exports.getAvatarGroupStyles = exports.getAvatarStyles = exports.avatarProfileSizes = exports.sizesMap = void 0;
var react_1 = require("@emotion/react");
var get_1 = __importDefault(require("lodash/get"));
var variables_1 = require("../../../style/variables");
exports.sizesMap = {
    '2xs': { root: 16, iconFont: 12, indicator: 4, groupMargin: 2, font: 10 },
    xs: { root: 24, iconFont: 16, indicator: 6, groupMargin: 4, font: 12 },
    sm: { root: 32, iconFont: 20, indicator: 8, groupMargin: 8, font: 14 },
    md: { root: 40, iconFont: 24, indicator: 10, groupMargin: 12, font: 16 },
    lg: { root: 48, iconFont: 28, indicator: 12, groupMargin: 16, font: 18 },
    xl: { root: 56, iconFont: 32, indicator: 14, groupMargin: 16, font: 20 },
    '2xl': { root: 64, iconFont: 32, indicator: 16, groupMargin: 16, font: 24 },
};
exports.avatarProfileSizes = {
    sm: { root: 72, iconFont: 36, indicator: 12, font: 30 },
    md: { root: 96, iconFont: 48, indicator: 12, font: 36 },
    lg: { root: 160, iconFont: 80, indicator: 16, font: 60 },
};
var badgePositions = {
    24: { bottom: 0, right: 0, boxShadow: '0 0 0 1.5px #FFFFFF' },
    32: { bottom: 0, right: 0, boxShadow: '0 0 0 1.5px #FFFFFF' },
    40: { bottom: 0, right: 0, boxShadow: '0 0 0 1.5px #FFFFFF' },
    48: { bottom: 0, right: 0, boxShadow: '0 0 0 1.5px #FFFFFF' },
    56: { bottom: 0, right: 0, boxShadow: '0 0 0 1.5px #FFFFFF' },
    64: { bottom: 0, right: 0, boxShadow: '0 0 0 1.5px #FFFFFF' },
    72: { bottom: 0, right: 6, boxShadow: '0 0 0 4px #FFFFFF' },
    96: { bottom: 2, right: 11, boxShadow: '0 0 0 4px #FFFFFF' },
    160: { bottom: 12, right: 14, boxShadow: '0 0 0 4px #FFFFFF' },
};
function getAvatarStyles(theme, wrapperSize, fontSize, indicatorSize) {
    return {
        root: react_1.css({
            position: 'relative',
            width: wrapperSize,
            height: wrapperSize,
            borderRadius: '50%',
        }),
        content: react_1.css({
            backgroundColor: theme.color.GRAY.LIGHT_5,
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            borderRadius: '50%',
            '& > img': {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
            },
        }),
        text: react_1.css({
            fontWeight: 600,
            color: theme.color.GRAY.DARK_1,
            fontSize: fontSize,
            textTransform: 'uppercase',
        }),
        indicator: react_1.css(__assign(__assign({ borderRadius: 100, position: 'absolute', width: indicatorSize, height: indicatorSize }, get_1.default(badgePositions, wrapperSize, {})), { display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' })),
    };
}
exports.getAvatarStyles = getAvatarStyles;
function getAvatarGroupStyles(theme, size) {
    return {
        avatarGroupWrapper: {
            display: 'flex',
            alignItems: 'center',
            '&  > div:first-of-type': {
                marginLeft: 0,
                boxShadow: '0 0 0 1.5px transparent',
            },
            '& > *': {
                marginLeft: -1 * exports.sizesMap[size].groupMargin,
                boxShadow: '0 0 0 1.5px white',
            },
        },
    };
}
exports.getAvatarGroupStyles = getAvatarGroupStyles;
function getAvatarAddBtnStyles(theme, size) {
    return {
        root: react_1.css({
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#fff',
            borderRadius: 200,
            justifyContent: 'center',
            fontSize: exports.sizesMap[size].iconFont,
            outline: 'none',
            cursor: 'pointer',
            border: "1px dashed " + theme.color.GRAY.LIGHT_2,
            color: theme.color.GRAY.LIGHT_1,
            overflow: 'hidden',
            width: exports.sizesMap[size].root,
            height: exports.sizesMap[size].root,
            '&:focus': {
                boxShadow: "0px 0px 0px 4px " + theme.color.GRAY.LIGHT_4,
                backgroundColor: '#fff',
            },
            '&:hover': {
                backgroundColor: theme.color.GRAY.LIGHT_5,
            },
            '&:disabled': {
                color: theme.color.GRAY.LIGHT_3,
                backgroundColor: theme.color.GRAY.LIGHT_5,
                borderColor: theme.color.GRAY.LIGHT_3,
                cursor: 'not-allowed',
            },
        }),
    };
}
exports.getAvatarAddBtnStyles = getAvatarAddBtnStyles;
var getOverlayInnerStyles = function (theme) { return ({
    opacity: 1,
    padding: 0,
    overflow: 'hidden',
    borderRadius: 8,
    background: theme.color.WHITE.DEFAULT,
    border: "1px solid " + theme.color.GRAY.LIGHT_4,
    boxShadow: "var(" + variables_1.Shadow.lg + ")",
}); };
exports.getOverlayInnerStyles = getOverlayInnerStyles;
